module.exports = __webpack_public_path__ + "static/media/teaconnection.5160f461.png";